import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "field-content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = {
  key: 0,
  class: "form"
}
const _hoisted_4 = { class: "w-50" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = {
  type: "button",
  disabled: ""
}
const _hoisted_10 = {
  type: "button",
  disabled: ""
}
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "actions" }
const _hoisted_13 = {
  type: "button",
  disabled: ""
}
const _hoisted_14 = {
  type: "button",
  disabled: ""
}
const _hoisted_15 = { class: "actions" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]

import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import {
  baseInput,
  baseSelect,
  baseConfirm,
  svgIcon,
} from "@/common/components";

import type {
  MethodFieldType,
  MethodFieldPayloadType,
} from "@/common/types/method/method-field";


export default /*@__PURE__*/_defineComponent({
  __name: 'method-field',
  props: {
    data: {},
    answer: { type: Boolean }
  },
  emits: ["cancel", "add", "edit", "del"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();



const emit = __emit;

const payloadDefault = {
  name: "",
  type: "text",
  required: false,
};

const payload = ref<MethodFieldPayloadType>({ ...payloadDefault });
const selected = ref<MethodFieldType | null>(null);
const showModalDel = ref(false);

const type = ref<string | null>(null);

const typeOptions = computed(() => [
  {
    option: t("common.labels.number"),
    value: "NUMBER",
  },
  {
    option: t("question.labels.range"),
    value: "RANGE",
  },
  {
    option: t("question.types.input"),
    value: "TEXT",
  },
  {
    option: t("question.types.textarea"),
    value: "TEXTAREA",
  },
]);

const delMessage = computed(() => {
  const message = t("method.texts.del_field_confirm", {
    concat: selected.value?.name,
  });
  const problem = t("common.texts.item_message");
  const undo = t("common.texts.undo_message");

  return `${message}<br>${problem}<br>${undo}`;
});

function cancel() {
  type.value = null;
  selected.value = null;
  showModalDel.value = false;
  payload.value = { ...payloadDefault };
}

function add() {
  type.value = "add";
  payload.value = { ...payloadDefault };
}

function addConfirm() {
  emit("add", payload.value);
  cancel();
}

function edit(field: MethodFieldType) {
  type.value = "edit";
  selected.value = field;
  payload.value = field;
}

function editConfirm() {
  emit("edit", payload.value);
  cancel();
}

function del(field: MethodFieldType) {
  selected.value = field;
  showModalDel.value = true;
}

function delConfirm() {
  emit("del", selected.value);
  cancel();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (type.value && payload.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(baseSelect), {
                modelValue: payload.value.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.type) = $event)),
                value: payload.value.type,
                options: typeOptions.value,
                "is-empty": false
              }, {
                label: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("common.labels.type")), 1)
                ]),
                _: 1
              }, 8, ["modelValue", "value", "options"])
            ]),
            _createVNode(_unref(baseInput), {
              modelValue: payload.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payload.value.name) = $event)),
              value: payload.value?.name,
              placeholder: _unref(t)('question.placeholders.name')
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)("common.labels.name")), 1)
              ]),
              _: 1
            }, 8, ["modelValue", "value", "placeholder"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        (type.value === 'add')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("button", {
                class: "btn btn-md btn-primary",
                type: "submit",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (addConfirm()))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "save",
                  size: "1.5rem"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.save")), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-md cancel",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel()))
              }, _toDisplayString(_unref(t)("common.labels.cancel")), 1)
            ], 64))
          : (type.value === 'edit')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("button", {
                  class: "btn btn-md btn-primary",
                  type: "submit",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (editConfirm()))
                }, [
                  _createVNode(_unref(svgIcon), {
                    icon: "edit",
                    size: "1.5rem"
                  }),
                  _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.edit")), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-md cancel",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (cancel()))
                }, _toDisplayString(_unref(t)("common.labels.cancel")), 1)
              ], 64))
            : (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: "btn btn-md btn-primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (add()))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "add",
                  size: "1rem"
                }),
                _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.add")), 1)
              ]))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)("common.labels.code")), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", _hoisted_9, [
            _createVNode(_unref(svgIcon), {
              icon: "edit",
              size: "1rem"
            })
          ]),
          _createElementVNode("button", _hoisted_10, [
            _createVNode(_unref(svgIcon), {
              icon: "trash",
              size: "1rem"
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", null, _toDisplayString(_unref(t)("common.labels.name")), 1),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", _hoisted_13, [
            _createVNode(_unref(svgIcon), {
              icon: "edit",
              size: "1rem"
            })
          ]),
          _createElementVNode("button", _hoisted_14, [
            _createVNode(_unref(svgIcon), {
              icon: "trash",
              size: "1rem"
            })
          ])
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (field, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item", {
            active: selected.value?.field_id === field.field_id,
          }])
        }, [
          _createElementVNode("div", null, _toDisplayString(field.name), 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              onClick: ($event: any) => (edit(field))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "edit",
                size: "1rem"
              })
            ], 8, _hoisted_16),
            _createElementVNode("button", {
              type: "button",
              onClick: ($event: any) => (del(field))
            }, [
              _createVNode(_unref(svgIcon), {
                icon: "trash",
                size: "1rem"
              })
            ], 8, _hoisted_17)
          ])
        ], 2))
      }), 128))
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showModalDel.value,
      title: _unref(t)('method.texts.del_field'),
      message: delMessage.value,
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (cancel())),
      onConfirm: _cache[8] || (_cache[8] = ($event: any) => (delConfirm()))
    }, null, 8, ["show", "title", "message"])
  ]))
}
}

})